import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
let packageJson = require('../../../package.json')

function Sidebar(props) {
    const location = useLocation();
    ;
    const [sidebar_selected, setSidebar_selected] = useState("");
    const [Menuselected, setMenuselected] = useState("");
    const [toggle_bit, settoggle_bit] = useState(0);
    const [target, setTarget] = useState({});

    useEffect(() => {
        setmenu()
    }, [location.pathname]);

    async function setmenu() {
        setMenuselected(await getmenu_fron_url())
        var root = document.getElementById("mainroot")
        if (root !== null) {
            if (root.classList.contains("mn--show")) {
                root.classList.remove("mn--show")
            }
        }
    }

    useEffect(() => {
        var elem = document.getElementById(target.name)
        if (elem !== null) {
            var sb = document.getElementById("scrollable-content")
            if (sb !== null) {
                const avi = window.innerHeight - target.event.y
                const scrollPosition = sb.scrollTop
                const elem_group = document.querySelectorAll("#" + target.name + ">.nav-item>.nav-link")
                const div_hi = (elem_group.length * 36) + 28
                var offs = (scrollPosition + 8)
                if (div_hi > avi) {
                    offs += (div_hi - avi)
                }
                elem.style.transform = "translate3d(55px, -" + offs + "px, 0px)"
            }
        }
    }, [target]);

    useEffect(() => {
        var root = document.getElementById("mainroot");
        document.querySelectorAll(".nav-toggler").forEach((e) => {
            e.addEventListener("click", async () => {
                if (window.innerWidth < 992) {
                    if (root.classList.contains("mn--max")) {
                        root.classList.remove("mn--max")
                    }
                    if (!root.classList.contains("mn--min")) {
                        root.classList.toggle("mn--min")
                    }

                    root.classList.toggle("mn--show")
                    if (root.classList.contains("mn--min") && root.classList.contains("mn--show")) {
                        settoggle_bit(1)
                    }
                } else {
                    if (root.classList.contains("mn--min") && root.classList.contains("mn--max")) {
                        setSidebar_selected("")
                        root.classList.toggle("mn--max");
                    } else {
                        if (root.classList.contains("mn--max")) {
                            setSidebar_selected("")
                        }
                        if (root.classList.contains("mn--min")) {
                            settoggle_bit(1)
                        } else {
                            settoggle_bit(2)
                        }
                        root.classList.toggle("mn--min")
                        root.classList.toggle("mn--max");
                    }
                }
            });
        })

        window.addEventListener("resize", (event) => {
            if (window.innerWidth < 992) {
                if (root.classList.contains("mn--max")) {
                    root.classList.toggle("mn--max");
                }
                if (!root.classList.contains("mn--min")) {
                    root.classList.toggle("mn--min");
                }
            } else {
                if (root.classList.contains("mn--show")) {
                    root.classList.toggle("mn--show");
                }
                if (root.classList.contains("mn--max")) {
                    if (root.classList.contains("mn--min")) {
                        root.classList.toggle("mn--min");
                    }
                } else {
                    if (!root.classList.contains("mn--min")) {
                        root.classList.toggle("mn--min");
                    }
                }
                // if (!root.classList.contains("mn--max")) {
                //     const elem_open = document.querySelectorAll(".nav-item.has-sub>ul.mininav-content.nav.collapse.show")
                //     if (elem_open.length > 0) {
                //         //setSidebar_selected("")
                //     }
                // }
            }
        });

        document.addEventListener("click", (e) => {
            if (e.target.classList.contains("root")) {
                if (!e.target.classList.contains('mininav-toggle')) {
                    if (root.classList.contains("mn--show")) {
                        root.classList.remove("mn--show")
                    }
                }
            }
        });

        document.querySelectorAll(".mininav-toggle.nav-link").forEach((e) => {
            e.addEventListener("mouseover", (event) => {
                if (root.classList.contains("mn--min") && !root.classList.contains("mn--show")) {
                    var rp = event.target.className.split(" ");
                    const myArray = rp[0].split("-");
                    setSidebar_selected(myArray[2])
                    setTarget({
                        name: myArray[2],
                        event: event,
                    })
                }
            });
        });
        document.querySelectorAll(".nav-item.has-sub").forEach((e) => {
            e.addEventListener("mouseleave", (event) => {
                if (root.classList.contains("mn--min") && !root.classList.contains("mn--show")) {
                    setSidebar_selected("")
                }
            });
        });
    }, [])

    useEffect(() => {
        if (toggle_bit === 1) {
            defaultoggle()
        }
        settoggle_bit(0)
    }, [toggle_bit]);

    function getmenuclass(url_expected) {
        if (url_expected === sidebar_selected) {
            if (Menuselected === url_expected) {
                return "active collapse"
            } else {
                return "collapse"
            }
        } else {
            if (Menuselected === url_expected) {
                return "active collapsed"
            } else {
                return "collapsed"
            }
        }
    }

    function toggle_menu(menu) {
        var root = document.getElementById("mainroot");
        if (!root.classList.contains("mn--min") || (root.classList.contains("mn--min") && root.classList.contains("mn--show"))) {
            setSidebar_selected(menu)
        }
    }

    async function defaultoggle() {
        const menu = await getmenu_fron_url()
        if (menu !== Promise) {
            setSidebar_selected(menu)
        }
    }

    function getmenu_fron_url() {
        return new Promise((resolve, reject) => {
            const myArray = location.pathname.split("/");
            if (myArray[1] === "appcenter" && myArray[2] === "dashboard" && myArray.length >= 4) {
                resolve(myArray[1] + "_" + myArray[2])
            } else if ((myArray[1] === "appcenter" || myArray[1] === "applocal") && myArray[2] === "historical" && myArray.length >= 4) {
                if ((myArray[3] === "historicaldata" || myArray[3] === "historicaldashboard" || myArray[3] === "report") && myArray.length > 4) {
                    resolve(myArray[1] + "_" + myArray[3])
                    // } else if (myArray[3] === "report") {
                    //     resolve(myArray[1] + "_" + myArray[3])
                } else {
                    resolve('')
                }
            } else if ((myArray[1] === "appcenter" || myArray[1] === "applocal") && myArray[2] === "alarmevent" && myArray.length === 4) {
                resolve(myArray[1] + "_" + myArray[2])
            } else if ((myArray[1] === "appcenter" || myArray[1] === "applocal") && myArray[2] === "reference" && myArray.length === 4) {
                resolve(myArray[1] + "_" + myArray[2])
            } else if ((myArray[1] === "appcenter" || myArray[1] === "applocal") && myArray[2] === "adminconsole" && myArray.length === 4) {
                resolve(myArray[1] + "_" + myArray[2])
            } else if (myArray[1] === "applocal" && (myArray[2] === "measurement" || myArray[2] === "plant") && myArray.length === 4) {
                resolve(myArray[1] + "_" + myArray[3])
            } else if (myArray[1] === "applocal" && myArray[2] === "cctv" && myArray.length === 4) {
                resolve(myArray[1] + "_" + myArray[2])
            } else if ((myArray[1] === "appcenter" || myArray[1] === "applocal") && myArray[2] === "document" && myArray.length === 3) {
                resolve(myArray[1] + "_" + myArray[2])
            } else {
                resolve('')
            }
        });
    }

    function CreateNavSubItemLink(path_url, display_name, kyx) {
        return <li className="nav-item" key={kyx}>
            <Link to={path_url} className={"nav-link " + (location.pathname === path_url ? "active" : "")} >{display_name}</Link>
        </li>
    }

    return (

        <nav id="mainnav-container" className="mainnav">
            <div className="mainnav__inner">
                <div className="mainnav__top-content scrollable-content pb-5" id="scrollable-content">
                    <div className="mainnav__categoriy py-3">
                        <ul className="mainnav__menu nav flex-column">
                            {
                                props.permitdata.view_mode === "center" ?
                                    <>
                                        <h6 className="mainnav__caption mt-0 px-3">DASHBOARD</h6>
                                        <li className="nav-item has-sub py-0">
                                            <Link className={"nav-mn-dashboard nav-link mininav-toggle " + getmenuclass("appcenter_dashboard")} onClick={() => { toggle_menu("appcenter_dashboard") }} ><i className="mdi mdi-monitor-dashboard fs-5 me-2"></i>
                                                <span className="nav-label mininav-content ms-1">Realtime Dashboard</span>
                                            </Link>
                                            <ul className={"mx-3 mininav-content nav collapse " + (sidebar_selected === "appcenter_dashboard" ? " show" : "")} >
                                                <li className="nav-item">
                                                    <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>Dashboard</span>
                                                </li>
                                                {CreateNavSubItemLink("/appcenter/dashboard/dboverall", "Overall")}
                                                {
                                                    props.permitdata !== null ?
                                                        props.permitdata.group_handle !== undefined ?
                                                            props.permitdata.group_handle.map((data, index) => (
                                                                CreateNavSubItemLink("/appcenter/dashboard/dbgroup/" + data, data + " Business", data)
                                                            ))
                                                            :
                                                            null
                                                        :
                                                        null
                                                }
                                                {CreateNavSubItemLink("/appcenter/dashboard/sitehealth", "Site Health")}
                                            </ul>
                                        </li>

                                        <h6 className="mainnav__caption mt-2 px-3">ALARM & EVENT SYSTEM</h6>
                                        <li className="nav-item has-sub py-1">
                                            <Link className={"nav-mn-appcenter_alarmevent nav-link mininav-toggle " + getmenuclass("appcenter_alarmevent")} onClick={() => { toggle_menu("appcenter_alarmevent") }} ><i className="mdi mdi-alert-rhombus-outline fs-5 me-2"></i>
                                                <span className="nav-label mininav-content ms-1">Alarm & Event</span>
                                            </Link>
                                            <ul id="appcenter_alarmevent" className={"mx-3 mininav-content nav collapse" + (sidebar_selected === "appcenter_alarmevent" ? " show" : "")} >
                                                <li className="nav-item">
                                                    <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>ALARM & EVENT</span>
                                                </li>
                                                {CreateNavSubItemLink("/appcenter/alarmevent/realtimeae", "Realtime Alarm")}
                                                {CreateNavSubItemLink("/appcenter/alarmevent/historicalae", "Historical A & E")}
                                            </ul>
                                        </li>

                                        <h6 className="mainnav__caption mt-2 px-3">HISTORICAL TRACKING</h6>
                                        <li className="nav-item has-sub py-1">
                                            <Link className={"nav-mn-historicaldashboard nav-link mininav-toggle " + getmenuclass("appcenter_historicaldashboard")} onClick={() => { toggle_menu("appcenter_historicaldashboard") }} ><i className="mdi mdi-table-search fs-5 me-2"></i>
                                                <span className="nav-label mininav-content ms-1">Historical Central</span>
                                            </Link>
                                            <ul className={"mx-3 mininav-content nav collapse " + (sidebar_selected === "appcenter_historicaldashboard" ? " show" : "")} >
                                                <li className="nav-item">
                                                    <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>HISTORICAL CENTRAL</span>
                                                </li>
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldashboard/overall", "Overall Track")}
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldashboard/business", "Business Track")}
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldashboard/multisites", "Multi Sites Track")}
                                            </ul>
                                        </li>
                                        <li className="nav-item has-sub py-1">
                                            <Link className={"nav-mn-historicaldata nav-link mininav-toggle " + getmenuclass("appcenter_historicaldata")} onClick={() => { toggle_menu("appcenter_historicaldata") }} ><i className="mdi mdi-table-search fs-5 me-2"></i>
                                                <span className="nav-label mininav-content ms-1">Historical Site</span>
                                            </Link>
                                            <ul className={"mx-3 mininav-content nav collapse " + (sidebar_selected === "appcenter_historicaldata" ? " show" : "")} >
                                                <li className="nav-item">
                                                    <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>HISTORICAL SITE</span>
                                                </li>
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldata/performance", "Performance")}
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldata/production", "Production")}
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldata/inverterpower", "Inverter Power")}
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldata/environment", "Environment")}
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldata/rawdata", "Raw Data Table")}
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldata/ensvalidation", "ENS Validation")}
                                                {CreateNavSubItemLink("/appcenter/historical/historicaldata/energycross", "Energy Cross Period")}
                                            </ul>
                                        </li>
                                        <li className="nav-item has-sub py-1">
                                            <Link className={"nav-mn-report nav-link mininav-toggle " + getmenuclass("appcenter_report")} onClick={() => { toggle_menu("appcenter_report") }} ><i className="mdi mdi-file-chart-outline fs-5 me-2"></i>
                                                <span className="nav-label mininav-content ms-1">Report Site</span>
                                            </Link>
                                            <ul className={"mx-3 mininav-content nav collapse " + (sidebar_selected === "appcenter_report" ? " show" : "")} >
                                                <li className="nav-item">
                                                    <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>REPORT SITE</span>
                                                </li>
                                                {CreateNavSubItemLink("/appcenter/historical/report/system", "System Report")}
                                                {CreateNavSubItemLink("/appcenter/historical/report/bill", "Billing Report")}
                                            </ul>
                                        </li>

                                        <>
                                            <h6 className="mainnav__caption mt-2 px-3">REFERENCE</h6>
                                            <li className="nav-item has-sub py-1">
                                                <Link className={"nav-mn-reference nav-link mininav-toggle " + getmenuclass("appcenter_reference")} onClick={() => { toggle_menu("appcenter_reference") }} ><i className="mdi mdi-calendar-edit fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Reference Parameter</span>
                                                </Link>
                                                <ul className={"mx-3 mininav-content nav collapse " + (sidebar_selected === "appcenter_reference" ? " show" : "")} >
                                                    <li className="nav-item">
                                                        <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>REFERENCE</span>
                                                    </li>
                                                    {CreateNavSubItemLink("/appcenter/reference/referenceunitrate", "Unit Rate")}
                                                    {CreateNavSubItemLink("/appcenter/reference/referenceft", "FT Charge")}
                                                    {CreateNavSubItemLink("/appcenter/reference/referenceholiday", "Holiday Calendar")}
                                                    {CreateNavSubItemLink("/appcenter/reference/referenceyear", "Yearly Reference")}
                                                    {CreateNavSubItemLink("/appcenter/reference/referencepurchase", "None Purchase")}
                                                </ul>
                                            </li>

                                            <h6 className="mainnav__caption mt-2 px-3">DOCUMENTS</h6>
                                            <li className="nav-item">
                                                <Link to="/appcenter/document" className={"nav-link mininav-toggle " + getmenuclass("appcenter_document")}><i className="mdi mdi-file-search-outline fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Project Documents</span>
                                                </Link>
                                            </li>
                                        </>

                                        {
                                            props.permitdata.user_role === 'Admin' ?
                                                <>
                                                    <h6 className="mainnav__caption mt-2 px-3">ADMINISTRATIVE TOOL</h6>
                                                    <li className="nav-item has-sub py-1">
                                                        <Link className={"nav-mn-adminconsole nav-link mininav-toggle " + getmenuclass("appcenter_adminconsole")} onClick={() => { toggle_menu("appcenter_adminconsole") }} ><i className="mdi mdi-tools fs-5 me-2"></i>
                                                            <span className="nav-label mininav-content ms-1">ADMINISTRATIVE TOOL</span>
                                                        </Link>
                                                        <ul className={"mx-3 mininav-content nav collapse " + (sidebar_selected === "appcenter_adminconsole" ? " show" : "")} >
                                                            <li className="nav-item">
                                                                <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>ADMINISTRATIVE TOOL</span>
                                                            </li>
                                                            {CreateNavSubItemLink("/appcenter/adminconsole/users", "Users Authentication")}
                                                            {CreateNavSubItemLink("/appcenter/adminconsole/sites", "Sites Info")}
                                                            {CreateNavSubItemLink("/appcenter/adminconsole/inverteralarm", "Inverter Alarm")}
                                                            {CreateNavSubItemLink("/appcenter/adminconsole/document", "Project Document")}
                                                            {CreateNavSubItemLink("/appcenter/adminconsole/wakeup", "PC Wake On LAN")}
                                                            {/* {CreateNavSubItemLink("/appcenter/adminconsole/refbill", "Bill Parameter")} */}
                                                            {CreateNavSubItemLink("/appcenter/adminconsole/meter5m", "Meter Cal. 5 minutes")}
                                                            {CreateNavSubItemLink("/appcenter/adminconsole/meterreverse", "Meter Reverse")}
                                                            {CreateNavSubItemLink("/appcenter/adminconsole/downloadcenter", "Download Center")}
                                                            {CreateNavSubItemLink("/appcenter/adminconsole/appupdate", "App Update")}
                                                        </ul>
                                                    </li>
                                                </>
                                                :
                                                null
                                        }
                                    </>
                                    : props.permitdata.view_mode === "local" ?
                                        <>
                                            <li className="nav-item">
                                                <Link to="/applocal/plant/siteinfo" className={"nav-link mininav-toggle " + getmenuclass("applocal_siteinfo")} ><i className="mdi mdi-factory fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Site Information</span>
                                                </Link>
                                            </li>
                                            <h6 className="mainnav__caption mt-2 px-3">MEASUREMENT SYSTEM</h6>
                                            <li className="nav-item">
                                                <Link to="/applocal/measurement/overview" className={"nav-link mininav-toggle " + getmenuclass("applocal_overview")} ><i className="mdi mdi-monitor-dashboard fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Overview</span>
                                                </Link>
                                            </li>
                                            <li className="nav-item d-block d-md-none">
                                                <Link to="/applocal/measurement/environment" className={"nav-link mininav-toggle " + getmenuclass("applocal_environment")}><i className="mdi mdi-weather-partly-cloudy fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Environment</span>
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/applocal/measurement/pvlaout" className={"nav-link mininav-toggle " + getmenuclass("applocal_pvlaout")}><i className="mdi mdi-view-week-outline fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">PV Layout</span>
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/applocal/measurement/inverters" className={"nav-link mininav-toggle " + getmenuclass("applocal_inverters")}><i className="mdi mdi-solar-power fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Inverters</span>
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/applocal/measurement/metering" className={"nav-link mininav-toggle " + getmenuclass("applocal_metering")}><i className="mdi mdi-speedometer fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Metering</span>
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/applocal/measurement/systemperformance" className={"nav-link mininav-toggle " + getmenuclass("applocal_systemperformance")}><i className="mdi mdi-chart-pie fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">System Performance</span>
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/applocal/measurement/indicator" className={"nav-link mininav-toggle " + getmenuclass("applocal_indicator")}><i className="mdi mdi-widgets-outline fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Status Indicator</span>
                                                </Link>
                                            </li>
                                            <h6 className="mainnav__caption mt-2 px-3">CCTV SYSTEM</h6>
                                            <li className="nav-item">
                                                <Link to="/applocal/cctv/streaming" className={"nav-link mininav-toggle " + getmenuclass("applocal_cctv")}><i className="mdi mdi-cctv fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">CCTV Live View</span>
                                                </Link>
                                            </li>
                                            <h6 className="mainnav__caption mt-2 px-3">ALARM & EVENT SYSTEM</h6>
                                            <li className="nav-item has-sub py-1">
                                                <Link className={"nav-mn-applocal_alarmevent nav-link mininav-toggle " + getmenuclass("applocal_alarmevent")} onClick={() => { toggle_menu("applocal_alarmevent") }} ><i className="mdi mdi-alert-rhombus-outline fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Alarm & Event</span>
                                                </Link>
                                                <ul id="applocal_alarmevent" className={"mx-3 mininav-content nav collapse" + (sidebar_selected === "applocal_alarmevent" ? " show" : "")} >
                                                    <li className="nav-item">
                                                        <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>ALARM & EVENT</span>
                                                    </li>
                                                    {CreateNavSubItemLink("/applocal/alarmevent/realtimeae", "Realtime Alarm")}
                                                    {CreateNavSubItemLink("/applocal/alarmevent/historicalae", "Historical A & E")}
                                                </ul>
                                            </li>

                                            <h6 className="mainnav__caption mt-2 px-3">HISTORICAL TRACKING</h6>
                                            <li className="nav-item has-sub py-1">
                                                <Link to="#" className={"nav-mn-applocal_historicaldata nav-link mininav-toggle " + getmenuclass("applocal_historicaldata")} onClick={() => { toggle_menu("applocal_historicaldata") }} ><i className="mdi mdi-table-search fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Historical Data</span>
                                                </Link>
                                                <ul id="applocal_historicaldata" className={"mx-3 mininav-content nav collapse" + (sidebar_selected === "applocal_historicaldata" ? " show" : "")} >
                                                    <li className="nav-item">
                                                        <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>HISTORICAL DATA</span>
                                                    </li>
                                                    {CreateNavSubItemLink("/applocal/historical/historicaldata/performance", "Performance")}
                                                    {CreateNavSubItemLink("/applocal/historical/historicaldata/production", "Production")}
                                                    {CreateNavSubItemLink("/applocal/historical/historicaldata/inverterpower", "Inverter Power")}
                                                    {CreateNavSubItemLink("/applocal/historical/historicaldata/environment", "Environment")}
                                                    {CreateNavSubItemLink("/applocal/historical/historicaldata/rawdata", "Raw Data Table")}
                                                    {CreateNavSubItemLink("/applocal/historical/historicaldata/ensvalidation", "ENS Validation")}
                                                    {CreateNavSubItemLink("/applocal/historical/historicaldata/energycross", "Energy Cross Period")}
                                                    {/* {CreateNavSubItemLink("/applocal/historical/historicaldata/rawcustom", "Raw Data Custom")} */}
                                                </ul>
                                            </li>
                                            <li className="nav-item has-sub py-1">
                                                <Link className={"nav-mn-report nav-link mininav-toggle " + getmenuclass("applocal_report")} onClick={() => { toggle_menu("applocal_report") }} ><i className="mdi mdi-file-chart-outline fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Report</span>
                                                </Link>
                                                <ul className={"mx-3 mininav-content nav collapse " + (sidebar_selected === "applocal_report" ? " show" : "")} >
                                                    <li className="nav-item">
                                                        <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>REPORT</span>
                                                    </li>
                                                    {CreateNavSubItemLink("/applocal/historical/report/system", "System Report")}
                                                    {CreateNavSubItemLink("/applocal/historical/report/bill", "Billing Report")}
                                                </ul>
                                            </li>

                                            <h6 className="mainnav__caption mt-2 px-3">REFERENCE</h6>
                                            <li className="nav-item has-sub py-1">
                                                <Link className={"nav-mn-applocal_reference nav-link mininav-toggle " + getmenuclass("applocal_reference")} onClick={() => { toggle_menu("applocal_reference") }} ><i className="mdi mdi-calendar-edit fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Reference Parameter</span>
                                                </Link>
                                                <ul id="applocal_reference" className={"mx-3 mininav-content nav collapse " + (sidebar_selected === "applocal_reference" ? " show" : "")} >
                                                    <li className="nav-item">
                                                        <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>REFERENCE</span>
                                                    </li>
                                                    {CreateNavSubItemLink("/applocal/reference/referenceunitrate", "Unit Rate")}
                                                    {CreateNavSubItemLink("/applocal/reference/referenceft", "FT Charge")}
                                                    {CreateNavSubItemLink("/applocal/reference/referenceholiday", "Holiday Calendar")}
                                                    {CreateNavSubItemLink("/applocal/reference/referenceyear", "Yearly Reference")}
                                                </ul>
                                            </li>

                                            <h6 className="mainnav__caption mt-2 px-3">DOCUMENTS</h6>
                                            <li className="nav-item">
                                                <Link to="/applocal/document" className={"nav-link mininav-toggle " + getmenuclass("applocal_document")}><i className="mdi mdi-file-search-outline fs-5 me-2"></i>
                                                    <span className="nav-label mininav-content ms-1">Project Documents</span>
                                                </Link>
                                            </li>

                                            {
                                                props.permitdata.user_role === 'Admin' ?
                                                    <>
                                                        <h6 className="mainnav__caption mt-2 px-3">ADMINISTRATIVE TOOL</h6>
                                                        <li className="nav-item has-sub py-1">
                                                            <Link className={"nav-mn-applocal_adminconsole nav-link mininav-toggle " + getmenuclass("applocal_adminconsole")} onClick={() => { toggle_menu("applocal_adminconsole") }} ><i className="mdi mdi-tools fs-5 me-2"></i>
                                                                <span className="nav-label mininav-content ms-1">ADMINISTRATIVE TOOL</span>
                                                            </Link>
                                                            <ul id="applocal_adminconsole" className={"mx-3 mininav-content nav collapse " + (sidebar_selected === "applocal_adminconsole" ? " show" : "")}  >
                                                                <li className="nav-item">
                                                                    <span className="nav-label-header-pop ms-1" style={{ color: "white" }}>ADMINISTRATIVE TOOL</span>
                                                                </li>

                                                                {CreateNavSubItemLink("/applocal/adminconsole/users", "Users Authentication")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/common", "Common System")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/centertransfer", "Center Transfer")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/solarmeter", "Solar Meter")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/gridmeter", "Grid Meter")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/inverter", "Inverter")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/pvlayout", "PV Layout")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/environment", "Environment")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/inverteralarm", "Inverter Alarm")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/notify", "Alarm Notify")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/cctv", "CCTV")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/iotmodule", "IOT Module")}
                                                                {CreateNavSubItemLink("/applocal/adminconsole/restore", "Backup & Restore")}
                                                            </ul>
                                                        </li>
                                                    </>
                                                    :
                                                    null
                                            }
                                        </>
                                        :
                                        null

                            }
                            <div className='d-block d-md-none'>
                                <h6 className="mainnav__caption mt-0 px-3">SECURITY</h6>
                                <li className="nav-item">
                                    <Link className="nav-link mininav-toggle " onClick={() => { props.callback_signout('x') }}><i className="mdi mdi-logout fs-5 me-2"></i>
                                        <span className="nav-label mininav-content ms-1">Logout</span>
                                    </Link>
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>

                <div className='sb-version'>Version {packageJson.version}</div>
            </div>
        </nav>
    )
}

export default Sidebar